/**
 * test
 *  开发环境：129.204.149.109:8087
 *  测试环境：129.204.149.109:8088
 *  生产环境 (线上！！！)：129.204.149.109:7980
 * */

// 生产环境
 let domainHost = 'http://129.204.149.109:7980';

// 测试环境
//let domainHost = 'http://129.204.149.109:8088';

// 开发环境
// let domainHost = 'http://10.35.0.34:8087';
// let domainHost = 'http://10.35.0.76:8087';

let audiohost = 'http://kfe.luyuaqua.com/overviewapi';

export default {
  domain: domainHost,
  audiohost,
  resourcesDomain: '',
};
